import React from "react";
import { LuiButton, LuiStaticMessage } from "@linzjs/lui";
import { withRouter } from "react-router";

class RequestFiles extends React.Component {

  searchAgain() {
    this.props.history.push("/search");
  }

  render() {
    const error = this.props.location.state.error;
    return (
      <>
        <div className="g-flex-col-sm-12">
          <div className="lui-text-content-area">
            <h2 className="demo-type">ELFI (Electronic LINZ File Index)</h2>
            {
              error ? (
                <LuiStaticMessage level="error" closable={false}>
                  <p>Sorry - this request cannot be processed at the moment.</p>
                </LuiStaticMessage>
              ) : (
                <LuiStaticMessage level="success" closable={false}>
                  <p>Your request is being processed.  You will be notified by the Regional Team Member Operations Support when the file(s) is available.</p>
                </LuiStaticMessage>
              )
            }
            <p>You can also <LuiButton level="text" onClick={() => this.searchAgain()}>carry out another search</LuiButton></p>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(RequestFiles);
